import Long from 'long';
import {DATE_TIME_FORMAT} from './format';
import formatUnix from '../time/formatUnix';

export const formatDateTimeUnix = (stamp?: Long | null, formatStr: string = DATE_TIME_FORMAT): string => {
  return formatUnix(stamp, formatStr);
};

export default formatDateTimeUnix;